<template>
  <el-upload
    class="avatar-uploader"
    :action="actionadd()"
    name="image"
    :disabled="showimg"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload">
    <div :style="{ width: width_+'px', height: height_ + 'px' }" v-if="imageUrl" class="imgbox">
      <img :src="imageUrl" class="avatar">
      <!-- <div><span>修改</span></div> -->
    </div>
    <i :style="{ width: width_+'px', height: height_ + 'px' }" v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
  
</template>
<script>
export default {
    data() {
      return {
        width_:this.size.width,
        height_:this.size.height,
        imageUrl: !!this.img?'http://s.laoyaoba.com/'+this.img:'',
        // isdisabled:false,
      };
    },
    props:['img','size','showimg'],
    watch:{
      // dialogposition(){
      //   if(this.dialogposition === "发布职位"){
      //     this.isdisabled = true;
      //   }else {
      //     this.isdisabled = false;
      //   }
      // },
      img(){
        this.imageUrl = !!this.img?'http://s.laoyaoba.com/'+this.img:''
      },
      size(){
        this.width_ = this.size.width;
        this.height_ = this.size.height;
      }
    },
    created(){},
    methods: {
      actionadd(){
        var api = ''//process.env.VUE_APP_BASE_API
        return api+'/api/tool/upload/image'
      },
      handleAvatarSuccess(res, file) {
        this.$emit("getimg",res);
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||file.type === 'image/jpg'||file.type === 'image/png'||file.type === 'image/gif';
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
          this.$message.error('上传图片格式错误!');
        }
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isJPG && isLt5M;
      }
    }
  }
</script>
<style scoped>
  .imgbox{
    position: relative;
    /* width: 200px; */
    /* height: 200px; */
    overflow: hidden;
    margin: 10px 0;
  }
  .imgbox div{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    background: rgba(0,0,0,.4);
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items:center;
    justify-content: center;
    -webkit-justify-content:center;
  }
  .imgbox span{
      padding: 2px 10px;
      cursor: pointer;
      border-radius: 3px;
      background-color: #409EFF;
      color: #ffffff;
      line-height: normal!important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9!important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9!important;
    font-size: 28px;
    color: #8c939d;
    margin: 10px 0;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items:center;
    justify-content: center;
    -webkit-justify-content:center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/uploadimg/index.vue